// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/ABCWhyteInktrap-Book.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "WhyteInktrap";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("opentype");
}
* {
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
}

html, body {
  color: #222228;
}

.Input_inputWrapper__faV4N {
  display: flex;
  padding: 0 10px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  font-size: 14px;
  align-items: center;
  width: 200px;
}
.Input_inputWrapper__faV4N input {
  outline: none;
  border: none;
  font-size: 14px;
  font-family: "Inter", sans-serif, sans-serif;
}
.Input_inputWrapper__faV4N.Input_focus__S3RR1 {
  border: 1px solid #D7B7FF;
}
.Input_inputWrapper__faV4N img {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/core/styles.scss","webpack://./src/components/Input/Input.module.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,+DAAA;ACCF;AD0BA;EACE,sBAAA;EACA,gCAzBS;ACCX;;AD2BA;EACE,cAVY;ACdd;;AATA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAYF;AAVE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AAYJ;AATE;EACE,yBAAA;AAWJ;AARE;EACE,WAAA;EACA,YAAA;AAUJ","sourcesContent":["@font-face {\n  font-family: 'WhyteInktrap';\n  src: url('./../assets/fonts/ABCWhyteInktrap-Book.otf') format('opentype');\n}\n\n//FONTS\n$mainFont: 'Inter', sans-serif;\n$secondaryFont: 'WhyteInktrap', sans-serif;\n\n// COLORS\n$lightBlue: #DDEAFB;\n$mediumBlue: #B4E1FA;\n$blue: #23A0E5;\n$darkBlue: #60748E;\n$lightGrey: #EAECF0;\n$lightOrange: rgba(250, 182, 145, 0.76);\n$orange: #FF7427;\n$red: #C60C30;\n$plusGreen: #EBFF99;\n$lightGreen: #7ADDAF;\n$green: #007940;\n$darkGreen: #112C22;\n$purple: #D7B7FF;\n$lightPurple: #DBD7FC;\n\n$primaryDark: #222228;\n$secondaryDark: #122D62;\n$white: #FFFFFF;\n\n* {\n  box-sizing: border-box;\n  font-family: $mainFont;\n}\n\nhtml, body {\n  color: $primaryDark;\n}","@import '../../core/styles';\n\n.inputWrapper {\n  display: flex;\n  padding: 0 10px;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid $lightGrey;\n  font-size: 14px;\n  align-items: center;\n  width: 200px;\n\n  input {\n    outline: none;\n    border: none;\n    font-size: 14px;\n    font-family: $mainFont, sans-serif;\n  }\n\n  &.focus {\n    border: 1px solid $purple;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `Input_inputWrapper__faV4N`,
	"focus": `Input_focus__S3RR1`
};
export default ___CSS_LOADER_EXPORT___;
